import React from "react";
import {Typography} from 'antd';

const {Title} = Typography;

const AppTitle = (props) => {

	return (
		<div className={'app-title'}>
			<Title level={2}>{props.title}</Title>
		</div>
	);
};

export default AppTitle;